import { useEffect, useState } from "react";
import { motion } from "framer-motion";

const STORAGE_KEY = "scout_deck_access";
const ANSWER = "tony";

export default function PasswordGate({ children }) {
  const [unlocked, setUnlocked] = useState(false);
  const [hydrated, setHydrated] = useState(false);
  const [value, setValue] = useState("");
  const [error, setError] = useState(false);

  useEffect(() => {
    try {
      if (localStorage.getItem(STORAGE_KEY) === "1") {
        setUnlocked(true);
      }
    } catch {
      /* ignore */
    }
    setHydrated(true);
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (value.trim().toLowerCase() === ANSWER) {
      try {
        localStorage.setItem(STORAGE_KEY, "1");
      } catch {
        /* ignore */
      }
      setUnlocked(true);
    } else {
      setError(true);
      setTimeout(() => setError(false), 600);
    }
  };

  if (!hydrated) return null;
  if (unlocked) return children;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-white px-6"
      data-testid="password-gate"
    >
      <motion.div
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
        className="w-full max-w-md flex flex-col items-start"
      >
        <div className="flex items-center gap-2 mb-12">
          <span className="block w-2 h-2 rounded-full bg-[var(--scout-blue)]" />
          <span className="font-mono text-[11px] tracking-[0.18em] text-neutral-500 uppercase">
            Scout Platform &middot; Seed Deck
          </span>
        </div>

        <div className="font-mono text-[10px] tracking-[0.22em] uppercase text-[var(--scout-blue)] mb-3 flex items-center gap-3">
          <span className="block w-8 h-px bg-[var(--scout-blue)]" />
          Access Required
        </div>

        <h1 className="font-display text-2xl md:text-3xl font-medium leading-[1.15] text-neutral-900 mb-8">
          First name of who built this site that you are wanting access to?
        </h1>

        <form onSubmit={handleSubmit} className="w-full">
          <motion.div
            animate={
              error ? { x: [-8, 8, -6, 6, -3, 3, 0] } : { x: 0 }
            }
            transition={{ duration: 0.5 }}
          >
            <input
              type="text"
              autoFocus
              value={value}
              onChange={(e) => setValue(e.target.value)}
              placeholder="Answer"
              data-testid="password-input"
              className={`w-full bg-transparent border-b-2 ${
                error ? "border-red-500" : "border-neutral-900"
              } focus:border-[var(--scout-blue)] outline-none font-display text-2xl md:text-3xl text-neutral-900 placeholder-neutral-300 py-3 transition-colors`}
            />
          </motion.div>

          <div className="flex items-center justify-between mt-8">
            <span className="font-mono text-[10px] tracking-[0.22em] uppercase text-neutral-400">
              {error ? "Try again" : "Press enter"}
            </span>
            <button
              type="submit"
              data-testid="password-submit"
              className="group flex items-center justify-center h-14 w-14 bg-white border-[3px] border-neutral-900 rounded-full shadow-[4px_4px_0_0_#0a0a0a] active:shadow-[1px_1px_0_0_#0a0a0a] active:translate-x-[3px] active:translate-y-[3px] transition-all duration-150 ease-out hover:bg-[var(--scout-blue)] hover:text-white hover:border-[var(--scout-blue)]"
              aria-label="Submit"
            >
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path
                  d="M4 10 L16 10 M11 5 L16 10 L11 15"
                  stroke="currentColor"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
          </div>
        </form>
      </motion.div>
    </div>
  );
}
